import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'

import { getDeviceString } from 'common/misc'
import colors from 'common/colors'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { get } from 'es-toolkit/compat'
import React, { type ReactElement } from 'react'

import * as c from 'common/c'
import { TEST_IDS } from 'test-ids'

import type { AppState } from 'state/index'
import AdBanner from './AdBanner'

const borderBottomCustomStyle = { borderBottom: 'none' }

export default function HardwareComponent(): ReactElement<any, any> {
  const { t } = useTranslation()
  const customClaims = useSelector(
    (state: AppState) => state.account.customClaims,
  )
  const permissions = useSelector(
    (state) => (state as AppState).account.permissions,
  )
  const isAdmin =
    permissions.includes('farmtrx:admin') || customClaims?.[c.FT_ADMIN_CLAIM]

  const hardware = useSelector((state) =>
    get(state as AppState, 'hardware.collection', []),
  )

  return (
    <>
      {/* <Box width={1} > */}
      {
        <Box
          style={{ overflowX: 'auto' }}
          sx={{
            padding: '1rem',
            width: 1,
          }}
        >
          <h1>{t('hardware')}</h1>
          <AdBanner />
          {
            <Box
              sx={{
                my: 1,
                border: `1px solid ${colors.brand}`,
                borderRadius: '2px',
              }}
            >
              {
                <TableContainer>
                  {
                    <Table aria-label="FarmTRX Hardware table" stickyHeader>
                      {
                        <TableHead>
                          {
                            <TableRow>
                              {
                                <TableCell align="left">
                                  {t('hardware_id')}
                                </TableCell>
                              }
                              {
                                <TableCell align="left">
                                  {t('hardware_type')}{' '}
                                </TableCell>
                              }
                              {
                                <TableCell align="left">
                                  {t('hardware_image')}{' '}
                                </TableCell>
                              }
                              {
                                <TableCell align="left">
                                  {t('hardware_name')}
                                </TableCell>
                              }
                              {isAdmin ? (
                                <TableCell align="left">
                                  {t('hardware_version')}{' '}
                                </TableCell>
                              ) : null}
                              {
                                <TableCell align="left">
                                  {t('firmware_version')}
                                </TableCell>
                              }
                            </TableRow>
                          }
                        </TableHead>
                      }
                      {
                        <TableBody>
                          {hardware && hardware.length ? (
                            hardware &&
                            hardware.map((row, index) => (
                              <TableRow key={index}>
                                {
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={borderBottomCustomStyle}
                                  >
                                    {row.farmtrxHardwareId}
                                  </TableCell>
                                }
                                {
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={borderBottomCustomStyle}
                                  >
                                    {t(row.hardwareType.toLowerCase())}
                                  </TableCell>
                                }
                                {
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={borderBottomCustomStyle}
                                  >
                                    {row.hardwareImage && (
                                      <img
                                        src={row.hardwareImage}
                                        alt={`${t(row.hardwareType.toLowerCase())} image for hardware ID ${row.farmtrxHardwareId}`}
                                        style={{ maxWidth: 48, maxHeight: 48 }}
                                        loading="lazy"
                                      />
                                    )}
                                  </TableCell>
                                }
                                {
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={borderBottomCustomStyle}
                                  >
                                    {getDeviceString(
                                      Number(row.deviceType),
                                      Number(row.hardwareVersion),
                                    )}
                                  </TableCell>
                                }
                                {isAdmin ? (
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={borderBottomCustomStyle}
                                  >
                                    {row.hardwareVersion}
                                  </TableCell>
                                ) : null}
                                {
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    sx={borderBottomCustomStyle}
                                  >
                                    {Array.isArray(
                                      (row as any)?.metadata?.firmware_version,
                                    ) &&
                                    (row as any)?.metadata?.firmware_version
                                      .length > 0
                                      ? (row as any).metadata.firmware_version[
                                          (row as any)?.metadata
                                            ?.firmware_version.length - 1
                                        ].version
                                      : t('unknown')}
                                  </TableCell>
                                }
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              {
                                <TableCell>
                                  {
                                    <Box
                                      sx={{
                                        width: 1,
                                        justifyContent: 'center',
                                      }}
                                    >
                                      {t('hw_populate_cloud_upload_msg')}
                                    </Box>
                                  }
                                </TableCell>
                              }
                            </TableRow>
                          )}
                        </TableBody>
                      }
                    </Table>
                  }
                </TableContainer>
              }
            </Box>
          }
        </Box>
      }
    </>
  )
}
